import { SourceCodeIcon, ViewIcon } from "hugeicons-react";
import "../../../Styles/Layout/Resources/Buttons/PreviewToggleButton.css";
import { isPreviewable } from "../sandboxUtils";

interface PreviewToggleButtonProps {
  showPreview: boolean;
  setShowPreview: (showPreview: boolean) => void;
  content: string;
  language?: string;
}

export default function PreviewToggleButton({
  showPreview,
  setShowPreview,
  content,
  language,
}: PreviewToggleButtonProps) {
  if (!isPreviewable(content, language)) return null;

  return (
    <div className="resource-preview-toggle-container">
      <div
        className={`resource-preview-toggle-button ${showPreview ? '' : 'active'}`}
        onClick={() => setShowPreview(false)}
      >
        <SourceCodeIcon size={16} />
      </div>
      <div
        className={`resource-preview-toggle-button ${showPreview ? 'active' : ''}`}
        onClick={() => setShowPreview(true)}
      >
        <ViewIcon size={16} />
      </div>
    </div>
  );
}
